import { z } from 'zod';

export const StockTransferProductFormSchema = z.object({
    productId: z.string().min(1, 'Le produit est requis'),
    quantity: z.number().int().min(0, 'La quantité doit être positive'),
    packages: z.number().min(0, 'Le nombre de colis doit être positif').optional(),
    palette: z.number().min(0, 'Le nombre de palettes doit être positif').optional(),
    fullname: z.string().optional(),
    conditionning: z.number().optional(),
    packagesPerBatch: z.number().optional(),
    originStockAvailable: z.number().optional(),
    destinationStockAvailable: z.number().optional(),
});

export const StockTransferFormSchema = z.object({
    transferDate: z.string().min(1, 'La date de transfert est requise'),
    originColumnId: z.string().min(1, 'La colonne de départ est requise'),
    destinationColumnId: z.string().min(1, "La colonne d'arrivée est requise"),
    shouldUpdateStockImmediately: z.boolean(),
    products: z.array(StockTransferProductFormSchema).min(0),
});

export type StockTransferFormData = z.infer<typeof StockTransferFormSchema>;
export type StockTransferProductFormData = z.infer<typeof StockTransferProductFormSchema>;

export const defaultStockTransferValues: StockTransferFormData = {
    transferDate: '',
    originColumnId: '',
    destinationColumnId: '',
    shouldUpdateStockImmediately: false,
    products: [],
};
